import "./EmptyResultsComp.css";
import { defineComponent as h, computed as r, withDirectives as f, openBlock as o, createElementBlock as u, renderSlot as s, createElementVNode as a, normalizeClass as l, createBlock as c, createCommentVNode as n, toDisplayString as i, withCtx as C, createTextVNode as R, vShow as k } from "vue";
import { IconComp as I } from "./IconComp.js";
import { ButtonComp as v } from "./ButtonComp.js";
import { _ as B } from "./_plugin-vue_export-helper.dad06003.js";
const S = { class: "emptyResults" }, T = ["t-sel"], g = ["t-sel"], $ = ["t-sel"], w = /* @__PURE__ */ h({
  __name: "EmptyResultsComp",
  props: {
    title: {},
    subtitle: {},
    buttonText: {},
    headerIcon: {},
    tSel: { default: "emptyResults" },
    blueIcon: { type: Boolean, default: !1 },
    primaryGray: { type: Boolean, default: !1 }
  },
  emits: ["actionButtonClicked"],
  setup(p, { emit: m }) {
    const _ = m, t = p, y = r(() => !!(t.headerIcon || t.title || t.subtitle || t.buttonText)), d = r(() => t.blueIcon ? "emptyResults__icon--blueIcon" : "emptyResults__icon--grayIcon"), b = () => {
      _("actionButtonClicked");
    };
    return (e, E) => f((o(), u("div", S, [
      s(e.$slots, "icon", {}, () => [
        a("div", {
          class: l(["emptyResults__icon", d.value]),
          "t-sel": `${e.tSel}-icon`
        }, [
          t.headerIcon ? (o(), c(I, {
            key: 0,
            icon: t.headerIcon,
            height: "50px",
            width: "50px"
          }, null, 8, ["icon"])) : n("", !0)
        ], 10, T)
      ], !0),
      s(e.$slots, "default", {}, () => [
        a("p", {
          class: l(["emptyResults__title", { "emptyResults__title--primary-gray": e.primaryGray }]),
          "t-sel": `${e.tSel}-title`
        }, i(t.title), 11, g),
        t.subtitle ? (o(), u("p", {
          key: 0,
          class: l(["emptyResults__subtitle", { "emptyResults__subtitle--primary-gray": e.primaryGray }]),
          "t-sel": `${e.tSel}-subTitle`
        }, i(t.subtitle), 11, $)) : n("", !0)
      ], !0),
      s(e.$slots, "buttons", { buttonText: e.buttonText }, () => [
        e.buttonText ? (o(), c(v, {
          key: 0,
          "t-sel": `${e.tSel}-actionBtn`,
          onClick: b,
          large: "",
          blue: ""
        }, {
          default: C(() => [
            R(i(t.buttonText), 1)
          ]),
          _: 1
        }, 8, ["t-sel"])) : n("", !0)
      ], !0)
    ], 512)), [
      [k, y.value]
    ]);
  }
});
const z = /* @__PURE__ */ B(w, [["__scopeId", "data-v-c031ed82"]]);
export {
  z as EmptyResultsComp
};
//# sourceMappingURL=EmptyResultsComp.js.map
